// extracted by mini-css-extract-plugin
module.exports = {"Column":"column_Column__2HWaQ"};